import { render, staticRenderFns } from "./hxhibition-explain.vue?vue&type=template&id=0d8b6212&scoped=true"
import script from "./hxhibition-explain.vue?vue&type=script&lang=js"
export * from "./hxhibition-explain.vue?vue&type=script&lang=js"
import style0 from "./hxhibition-explain.vue?vue&type=style&index=0&id=0d8b6212&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d8b6212",
  null
  
)

export default component.exports